import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderRo = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="ÎNTORCEȚI ROATA ȘI PRIMIȚI ROTIRI GRATUITE"
            highlights={[{ word: 'ROTIRI' }, { word: 'GRATUITE' }]}
            breakAfterWords={isDesktop ? ['PRIMIȚI'] : ['ȘI']}
            className={common.text_header}
        />
    )
}

export const TextLandRo = () => {
    return (
        <HighlightedText
            text="Ați câștigat 400 de rotiri gratuite"
            highlights={[
                { word: '400' },
                { word: 'de' },
                { word: 'rotiri' },
                { word: 'gratuite' },
            ]}
            breakAfterWords={['Ați câștigat']}
            className={styles.text_content}
        />
    )
}
